import { IsolatedScanMotion } from "../types/types"
import { genericRequest, isolatedScanMotionRoute } from "./service"

export const getIsolatedScanMotion = async (sectionScanId: number): Promise<IsolatedScanMotion[] | Error> => {
  return await genericRequest({ url: `${isolatedScanMotionRoute}/isolated_scan_motions/${sectionScanId}`, method: "GET" })
}
/**
 * Creates an isolated scan motion entity in database.
 * 
 * @param motion to upload
 * 
 * @returns created isolated scan motion
 */
export const addIsolatedScanMotion = async (motion: IsolatedScanMotion, sectionScanId: number): Promise<IsolatedScanMotion | Error> => {
  return await genericRequest({ url: `${isolatedScanMotionRoute}/${sectionScanId}`, method: "POST", body: JSON.stringify(motion) })
}
